/**
 * Helpers for working with product images.
 *
 * The DB schema stores each image as `{url, alt}`. For safety during transition
 * and for any caller that might pass a raw string, these helpers normalize
 * everything to objects.
 */
export function imgUrl(img) {
  if (!img) return "";
  if (typeof img === "string") return img;
  return img.url || "";
}

export function imgAlt(img, fallback = "") {
  if (!img) return fallback;
  if (typeof img === "string") return fallback;
  return img.alt || fallback;
}

export function normalizeImages(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((it) => {
      if (typeof it === "string") return { url: it, alt: "" };
      if (it && typeof it === "object" && it.url) {
        return { url: String(it.url), alt: String(it.alt || "") };
      }
      return null;
    })
    .filter(Boolean);
}
